import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { CostOfInaction } from '../components/CostOfInaction';
import { TransformationSection } from '../components/TransformationSection';
import { MethodSection } from '../components/MethodSection';
import { StepsSection } from '../components/StepsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProofAndFAQ } from '../components/ProofAndFAQ';
import { OfferCTA } from '../components/OfferCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-night-900 text-cream-100 font-body selection:bg-gold-500/30" data-id="element-284">
      <Hero data-id="element-285" />
      <ProblemSection data-id="element-286" />
      <MethodSection data-id="element-287" />
      <StepsSection data-id="element-288" />
      <CostOfInaction data-id="element-289" />
      <TransformationSection data-id="element-290" />
      <TestimonialsSection data-id="element-291" />
      <AudienceSection data-id="element-292" />
      <ProofAndFAQ data-id="element-293" />
      <OfferCTA data-id="element-294" />
      <Footer data-id="element-295" />
    </main>;
}